import { MasteryChipOptions, SupportSkillChipOptions } from './ConstData';

class SupportCardModel {
    constructor(data) {
        this.cardName = data.cardName;
        this.character = data.character;
        this.ideaTFD = data.ideaTFD;
        this.ideaGRAD = data.ideaGRAD;
        this.cardSkills = data.cardSkills;
        this.skills = this.cardSkills.filter(x => !x.includes('マスタリー'));
        this.mastery = this.cardSkills.filter(x => x.includes('マスタリー'));
        this.distributionType = data.distributionType;
    }

    getChipData() {
        const colorTFD = MasteryChipOptions.find(x => x.label === this.ideaTFD).color;
        const colorGRAD = MasteryChipOptions.find(x => x.label === this.ideaGRAD).color;
        const ideaChips = [
            { label: '感謝祭:' + this.ideaTFD, color: colorTFD, textColor: this.ideaTFD === 'Me'? 'white': 'black'},
            { label: 'GRAD:' + this.ideaGRAD, color: colorGRAD, textColor: this.ideaGRAD === 'Me'? 'white': 'black'},
        ];
        const skillChips = this.cardSkills.map((d) => {
            const tmp = SupportSkillChipOptions.filter(x => x.label === d);
            const color = tmp.length !== 0 ? tmp[0].color: 'aliceblue';
            const chipData = {
                label: d,
                color: color,
            };

            // 配色設定
            if (d.includes('マスタリー')) {
                // この2つのみ濃色なので，文字色を白基調にする
                if (d.includes('ラジオマスタリーMe') || d.includes('テンションマスタリーMe')) {
                    chipData.textColor = 'white';
                }
                let bg = 'linear-gradient(90deg, ';

                // マスタリー条件を抽出し，前半の背景色を指定
                const condition = d.substring(0, d.indexOf('マスタリー'));
                let tmp = MasteryChipOptions.filter(x => x.label === condition);
                const startColor = tmp.length !== 0? tmp[0].color: 'aliceblue';
                bg += startColor + ', ' + startColor + ', ';

                // 伸びるステを抽出し，後半の背景色を指定
                const effect = d.substring(d.indexOf('マスタリー') + 5);
                // 上限が伸びるマスタリーの場合は，3色目を指定
                if (effect.includes('上限')) {
                    const effectHead = effect.substring(0, effect.indexOf('上限'));
                    tmp = MasteryChipOptions.filter(x => x.label === effectHead);
                    const secondColor = tmp.length !== 0? tmp[0].color: 'aliceblue';
                    const endColor = MasteryChipOptions.filter(x => x.label === '上限')[0].color;
                    bg += secondColor + ', ' + endColor + ')';
                } else {
                    tmp = MasteryChipOptions.filter(x => x.label === effect);
                    const secondColor = tmp.length !== 0? tmp[0].color: startColor;
                    bg += secondColor + ', ' + secondColor + ')';
                }
                chipData.background = bg;
            }
            return chipData;
        });

        return ideaChips.concat(skillChips);
    }
}

export default SupportCardModel;